<template>
  <transition name="mask">
    <div class="modal-mask" v-if="show" @click.self="hideModal(false)" :style="{'background-color': `rgba(0, 0, 0, ${opacity})`}">
      <div class="modal-wrapper" :style="{width}">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script type='text/ecmascript-6'>
export default {
  props: {
    width: {
      type: String,
      default: '315px'
    },
    opacity: {
      type: Number,
      default: 0.7
    },
    over_close: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    showModal () {
      this.show = true
      this._top = document.scrollingElement.scrollTop
      document.body.classList.add('body-fixed')
      document.body.style.top = -this._top + 'px'
      this.$emit('show')
    },
    hideModal (is_close = false) {
      if (this.over_close || is_close) {
        this.show = false
        document.body.classList.remove('body-fixed')
        document.scrollingElement.scrollTop = this._top;
        this.$emit('hide')
      }
    },
  }
}
</script>

<style lang="less">
.body-fixed {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.modal-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(#000, 0.5);
  z-index: 50;
  .modal-wrapper {
    width: 252px;
    min-height: 116px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    overflow: unset !important;
  }
}
.mask-enter-active, .mask-leave-active {
  transition: all 0.35s cubic-bezier(.42, 0, .58, 1);
}
.mask-enter, .mask-leave-to {
  opacity: 0;
}
.mask-enter-to, .mask-leave {
  opacity: 1;
}
</style>
